module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/4eWLKgVEp5K30Yb3YH2rxf-fd2b1532572611cf52661500ddd7ef37.jpg";